import debug from 'debug';
import { throttle, isString, set, get } from 'lodash-es';

const log = debug('itp:core:object-store');

export type StoreTypes = 'local' | 'remote';

export class ObjectStore {
  name: string;
  data: object;
  saveData: () => void;

  constructor(name: string) {
    this.name = 'object-store:' + name;
    this.saveData = throttle(this._saveData, 1000);
    this.data = this.loadData() || {};
  }

  async get(key: string, source: StoreTypes = 'local') {
    return await this.getLocal(key);
  }

  async set(key: string, value: any, dest: StoreTypes = 'local') {
    return await this.setLocal(key, value);
  }

  async getLocal(key: string) {
    const result = localStorage.getItem(key);
    if (isString(result)) {
      if (result === 'undefined') {
        return;
      }
      return JSON.parse(result);
    }
  }

  async setLocal(key: string, value: any) {
    log('setLocal - key=%s, value=%o', key, value);
    localStorage.setItem(key, JSON.stringify(value));
    return value;
  }

  setItem(path: string, value: any) {
    log('setItem - path=%s, value=%o', path, value);
    set(this.data, path, value);
    this.saveData();
  }

  getItem(path: string, defaultValue?: any) {
    let result = get(this.data, path, defaultValue);
    if (result === 'undefined') {
      result = defaultValue;
    }
    log('getItem - path=%s, result=%o', path, result);
    return result;
  }

  private loadData() {
    const result = localStorage.getItem(this.name);
    if (isString(result)) {
      return JSON.parse(result);
    }
  }

  private _saveData() {
    localStorage.setItem(this.name, JSON.stringify(this.data));
  }
}
